// src/confluence/workspace/types.ts
var ConfluenceWorkspaceAriResourceOwner = "confluence", ConfluenceWorkspaceAriResourceType = "workspace";

export {
  ConfluenceWorkspaceAriResourceOwner,
  ConfluenceWorkspaceAriResourceType
};
